import {useAppSelector} from "@Hooks/selector/useAppSelector";
import roundToTwoDecimals from "@Number/roundToTwoDecimals";
import useGetTotalPriceForSelectedAmenities
    from "@CheckOrder/features/paymentSummary/features/amenitiesSummary/hooks/useGetTotalPriceForSelectedAmenities";

export default function useGetDisplayPriceWithAncillariesAndAmenities(returnWithCurrency: boolean = false) {
    const {getTotalPriceForSelectedAmenities} = useGetTotalPriceForSelectedAmenities()

    const {
        ticket: {
            totalPrice,
            ancillariesData,
        },
        selectedServices: {
            isBuyingPremiumSupport,
            isBuyingSMSNotification,
            isBuyingTier1FlexibleCancellation,
        },
    } = useAppSelector((state) => state?.checkOrder);

    let priceFloat = parseFloat(totalPrice.split(" ")[0]);

    if (isBuyingPremiumSupport) {
        priceFloat = roundToTwoDecimals(priceFloat + ancillariesData.premiumSupport.displayPrice)
    }
    if (isBuyingSMSNotification) {
        priceFloat = roundToTwoDecimals(priceFloat + ancillariesData.smsNotification.displayPrice)
    }
    if (isBuyingTier1FlexibleCancellation) {
        priceFloat = roundToTwoDecimals(priceFloat + ancillariesData.tier1FlexibleCancellation.displayPrice)
    }

    priceFloat += getTotalPriceForSelectedAmenities()

    return (returnWithCurrency) ? `${priceFloat} ${ancillariesData.premiumSupport.displayCurrencySymbol}` : `${priceFloat}`;
}